import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const AuthSlider = () => {
    const domain = window.location.hostname;
    const [logoUrl, setLogoUrl] = useState(() => {
        try {
            const cachedData = localStorage.getItem(`custom_images_${domain}`);
            const cachedImages = cachedData ? JSON.parse(cachedData) : {};
            return cachedImages.logoWhite || cachedImages.logo || "/oplena-logo-light.png";
        } catch {
            return "/oplena-logo-light.png";
        }
    });
    const [logoWidth, setLogoWidth] = useState(90);

    const updateLogo = () => {
        try {
            const cachedData = localStorage.getItem(`custom_images_${domain}`);
            const cachedImages = cachedData ? JSON.parse(cachedData) : {};
            const newLogo = cachedImages.logoWhite || cachedImages.logo || "/oplena-logo-light.png";
            setLogoUrl(newLogo);
            setLogoWidth(cachedImages.logoLoginWidth || 90);
        } catch (error) {
            console.error('Erro ao carregar imagem do cache:', error);
            setLogoUrl("/oplena-logo-light.png");
        }
    };

    useEffect(() => {
        // Atualiza logo inicialmente
        updateLogo();

        // Listener para atualizar quando o localStorage mudar
        const interval = setInterval(() => {
            updateLogo();
        }, 500);

        // Cleanup após 5 segundos (tempo suficiente para API responder)
        const timeout = setTimeout(() => {
            clearInterval(interval);
        }, 5000);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, []);

    return (
        <div className="oplena-brand-panel">
            <div className="oplena-brand-panel__image" aria-hidden="true"></div>
            <div className="oplena-brand-panel__content">
                <Link to="/dashboard" className="oplena-brand-panel__logo-link">
                    <img src={logoUrl} alt="Grupo Oplena" style={{maxWidth: `${logoWidth}px`}} />
                </Link>

                <div className="oplena-brand-panel__message">
                    <p>GRUPO OPLENA</p>
                    <h2>Painel do<br />Grupo Oplena</h2>
                    <span>Um grupo, várias empresas.</span>
                </div>

                <div className="oplena-brand-panel__stats" aria-label="Informações do Grupo Oplena">
                    <div><strong>5+</strong><span>empresas</span></div>
                    <div><strong>2014</strong><span>desde</span></div>
                </div>
            </div>
        </div>
    );
};

export default AuthSlider;
